function processus() {
    $('.button-processus').on('click', function (e) {
        e.preventDefault();
        $('.processus-wrap').addClass('is-active');
        $('.processus-bg').addClass('is-active');

        $('html').css('overflow', 'hidden');
        $('#header').css('z-index','-1');
        
        $('div.close').on('click', function () {
            $(this).parent().find('img').addClass('is-hide');
            $('.processus-wrap').removeClass('is-active');
            $('.processus-bg').removeClass('is-active');
            // $('.processus-image img').remove();
            $('html').css('overflow', '');
            $('#header').css('z-index','1');
        });
    });
    if (
        $('.menu_cat_prod .nav_category .menu .current-menu-item').find('ul').length > 0
        ||$('.menu_cat_prod .nav_category .menu .current-menu-parent').find('ul').length > 0
    ) {
        $('.menu_cat_prod .nav_category .menu').css('padding-bottom', '85px');
    }
}

module.exports = function () {
    window.addEventListener('load ready resize', processus);
    processus();
};
